import { apenasNumeros } from "@/services/utils";

export const getItemsRequestBills = (values) => {
  const items = [];
  for (const item of values.pixs) {
    if (item.pixKey) {
      let pixKey = item.pixKey;
      if (item.pixType === "CpfCnpj" || item.pixType === "Telefone") {
        pixKey = apenasNumeros(pixKey);
      }
      items.push({
        ...item,
        pixKey: pixKey,
      });
    }
  }
  for (const item of values.boletos) {
    if (item.barcode) {
      items.push({
        ...item,
        barcode: apenasNumeros(item.barcode),
      });
    }
  }
  for (const item of values.ipvas) {
    if (item.car_plate) {
      items.push({
        ...item,
        barcode: `PLACA: ${item.car_plate} - RENAVAM: ${item.renavam}`,
      });
    }
  }
  return items;
};
